export let todos = [
  {
    id: 1,
    name: 'Example: Learn JavaScript',
    completed: true,
  },
  {
    id: 2,
    name: 'Example: Go shopping',
    completed: false,
  },
  {
    id: 3,
    name: 'Example: Bake cupcakes',
    completed: false,
  },
];
